/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfTearSheetFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfTearSheet } from '../../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v1/organizations/{organizationId}/customers/{customerNumber}/tearsheets
 */
export interface TearsheetsRequestBuilder extends BaseRequestBuilder<TearsheetsRequestBuilder> {
    /**
     * Retrieves a paginated list of TearSheets for a specific customer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfTearSheet>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<TearsheetsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfTearSheet | undefined>;
    /**
     * Retrieves a paginated list of TearSheets for a specific customer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TearsheetsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Retrieves a paginated list of TearSheets for a specific customer
 */
export interface TearsheetsRequestBuilderGetQueryParameters {
    pageNumber?: number;
    pageSize?: number;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const TearsheetsRequestBuilderUriTemplate = "{+baseurl}/api/v1/organizations/{organizationId}/customers/{customerNumber}/tearsheets?pageNumber={pageNumber}&pageSize={pageSize}{&useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TearsheetsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TearsheetsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfTearSheetFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
